export const mapFiltersData = (filters) => {
  return Object
    .keys(filters)
    .reduce((result, key: string) => {
      result[key] = Array.isArray(filters[key])
        ? filters[key]
          .map((item) => typeof item === "object"
            ? item.id
            : item)
        : filters[key]?.id || filters[key]
      return result
    }, {})
}
